// extracted by mini-css-extract-plugin
export default {"catchmentMap":"CatchmentSelectionPage_catchmentMap__jOzOT","infoIcon":"CatchmentSelectionPage_infoIcon__rbErp","selectionPage":"CatchmentSelectionPage_selectionPage__au7Aq"};